
import { BULK_INVENTORY_ITEM_MENU_ITEM } from "@/consts";
import BulkInventoryItemTable from "@/components/barcodeSystem/inventory/BulkInventoryItemTable.vue";
import BulkInventoryItemFilters from "@/components/barcodeSystem/inventory/BulkInventoryItemFilters.vue";
import InventoryActions from "@/components/barcodeSystem/inventory/InventoryActions.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import Component from "vue-class-component";

const inventoryModuleState = getModule(InventoryModule);

@Component({
  components: {
    BulkInventoryItemTable,
    InventoryActions,
    BulkInventoryItemFilters
  }
})
export default class BulkInventoryItems extends Vue {
  showBulkInventoryItemFieldFilter: boolean = false;
  truckMenuStyle: string = "";
  BULK_INVENTORY_ITEM_MENU_ITEM: any = BULK_INVENTORY_ITEM_MENU_ITEM;

  get bulkFields() {
    return inventoryModuleState.bulkFields;
  }

  async created() {
  }

  async loadMoreItems() {
    await inventoryModuleState.setLoading(true);
    await inventoryModuleState.getBulkInventoryItems(null);
    await inventoryModuleState.setLoading(false);
  }

  async onSort(s) {
    await inventoryModuleState.setLoading(true);
    await inventoryModuleState.applyBulkListSort(s);
    await inventoryModuleState.setLoading(false);
  }

  toggleChangeField(idx, hideShow) {
    inventoryModuleState.toggleBulkField({ idx: idx, value: !hideShow });
  }

  get menuItemsToDisplay() {
    return this.BULK_INVENTORY_ITEM_MENU_ITEM.filter(
      x => x.requiresPermission === undefined || this.hasPermission(x.requiresPermission)
    );
  }

  get dataRetreived() {
    if(inventoryModuleState.bulkData)
      return true;
    return false;
  }
}


